/**
 * This file demonstrates the process of starting WebRTC streaming using a KVS Signaling Channel.
 */
//'amazon-kinesis-video-streams-webrtc'
import { SignalingClient } from 'amazon-kinesis-video-streams-webrtc';
import { API_AUTH_TOKEN } from '../../Utils/constants';
import awsmobile from '../../aws-exports.js';
var AWS = require('aws-sdk');


//const viewer = {};
let connectionStatus = null;


export async function startViewer(viewer, formValues, onRemoteDataMessage, stateChangeNotifier) {
    //viewer.localView = localView;
    //viewer.remoteView = remoteView;

    AWS.config.region = awsmobile.aws_cognito_region;
    //console.dir(awsmobile);
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: awsmobile.aws_identity_pool_id,
        Logins: {
          ['cognito-idp.'+awsmobile.aws_cognito_region+'.amazonaws.com/'+awsmobile.aws_user_pools_id]: localStorage.getItem(API_AUTH_TOKEN)
        }
    });

    AWS.config.credentials.get(function(err,data) {
        if (err) {
            console.log("Error:" + err);
        }
      });
    //console.dir(AWS.config.credentials);
    // Create KVS client
    const kinesisVideoClient = new AWS.KinesisVideo({
        region: AWS.config.region,
        credentials: AWS.config.credentials,
        endpoint: formValues.endpoint,
        correctClockSkew: true,
    });
    //console.log("Channel: " + formValues.channelName);
    // Get signaling channel ARN
    /*
    const describeSignalingChannelResponse = await kinesisVideoClient
        .describeSignalingChannel({
            ChannelName: formValues.channelName,
        })
        .promise();
    */
    const channelARN = formValues.channelName;//describeSignalingChannelResponse.ChannelInfo.ChannelARN;
    //console.log('[VIEWER] Channel ARN: ', channelARN);

    // Get signaling channel endpoints
    const getSignalingChannelEndpointResponse = await kinesisVideoClient
        .getSignalingChannelEndpoint({
            ChannelARN: channelARN,
            SingleMasterChannelEndpointConfiguration: {
                Protocols: ['WSS', 'HTTPS'],
                Role: "VIEWER",
            },
        })
        .promise();
    const endpointsByProtocol = getSignalingChannelEndpointResponse.ResourceEndpointList.reduce((endpoints, endpoint) => {
        endpoints[endpoint.Protocol] = endpoint.ResourceEndpoint;
        return endpoints;
    }, {});
    //console.log('[VIEWER] Endpoints: ', endpointsByProtocol);


    const kinesisVideoSignalingChannelsClient = new AWS.KinesisVideoSignalingChannels({
        region: AWS.config.region,
        credentials:AWS.config.credentials,
        endpoint: endpointsByProtocol.HTTPS,
        correctClockSkew: true,
    });

    // Get ICE server configuration
    const getIceServerConfigResponse = await kinesisVideoSignalingChannelsClient
        .getIceServerConfig({
            ChannelARN: channelARN,
        })
        .promise();
    const iceServers = [];
    if (!formValues.natTraversalDisabled && !formValues.forceTURN) {
        iceServers.push({ urls: `stun:stun.kinesisvideo.${AWS.config.region}.amazonaws.com:443` });
    }
    if (!formValues.natTraversalDisabled) {
        getIceServerConfigResponse.IceServerList.forEach(iceServer =>
            iceServers.push({
                urls: iceServer.Uris,
                username: iceServer.Username,
                credential: iceServer.Password,
            }),
        );
    }
    //console.log('[VIEWER] ICE servers: ', iceServers);

    // Create Signaling Client
    viewer.signalingClient = new SignalingClient({
        channelARN,
        channelEndpoint: endpointsByProtocol.WSS,
        clientId: formValues.clientId,
        role: "VIEWER",
        region: AWS.config.region,
        credentials: AWS.config.credentials,
        systemClockOffset: kinesisVideoClient.config.systemClockOffset,
    });

    const resolution = formValues.widescreen ? { width: { ideal: 1280 }, height: { ideal: 720 } } : { width: { ideal: 640 }, height: { ideal: 480 } };
    const constraints = {
        video: formValues.sendVideo ? resolution : false,
        audio: formValues.sendAudio,
    };
    const configuration = {
        iceServers,
        iceTransportPolicy: formValues.forceTURN ? 'relay' : 'all',
    };
    viewer.peerConnection = new RTCPeerConnection(configuration);
    if (formValues.openDataChannel) {
        viewer.dataChannel = viewer.peerConnection.createDataChannel('kvsDataChannel');
        viewer.peerConnection.ondatachannel = event => {
            //event.channel.onmessage = onRemoteDataMessage;
        };        
    }
    if(viewer.peerConnection==null || viewer.peerConnection.getStats()==null){
        stopViewer(viewer);
        return;
    }

/*    
    // Poll for connection stats
    viewer.peerConnectionStatsInterval = setInterval(() => (
            viewer.peerConnection==null || viewer.peerConnection.getStats()?
            (viewer.peerConnection.getStats().then(onStatsReport), 1000):null
    ));
*/    
    viewer.signalingClient.on('open', async () => {
        console.log('[VIEWER] Connected to signaling service');

        // Get a stream from the webcam, add it to the peer connection, and display it in the local view.
        // If no video/audio needed, no need to request for the sources. 
        // Otherwise, the browser will throw an error saying that either video or audio has to be enabled.
        if (viewer.localView && (formValues.sendVideo || formValues.sendAudio)) {
            try {
                viewer.localStream = await navigator.mediaDevices.getUserMedia(constraints);
                viewer.localStream.getTracks().forEach(track => viewer.peerConnection.addTrack(track, viewer.localStream));
                viewer.localView.srcObject = viewer.localStream;
            } catch (e) {
                console.error('[VIEWER] Could not find webcam');
                return;
            }
        }

        // Create an SDP offer to send to the master
        console.log('[VIEWER] Creating SDP offer');
        await viewer.peerConnection.setLocalDescription(
            await viewer.peerConnection.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true,
            }),
        );

        // When trickle ICE is enabled, send the offer now and then send ICE candidates as they are generated. Otherwise wait on the ICE candidates.
        if (formValues.useTrickleICE) {
            console.log('[VIEWER] Sending SDP offer');
            viewer.signalingClient.sendSdpOffer(viewer.peerConnection.localDescription);
        }
        console.log('[VIEWER] Generating ICE candidates');
    });

    viewer.signalingClient.on('sdpAnswer', async answer => {
        // Add the SDP answer to the peer connection
        console.log('[VIEWER] Received SDP answer');
        await viewer.peerConnection.setRemoteDescription(answer);
    });

    viewer.signalingClient.on('iceCandidate', candidate => {
        // Add the ICE candidate received from the MASTER to the peer connection
        console.log('[VIEWER] Received ICE candidate');
        viewer.peerConnection.addIceCandidate(candidate);
    });

    viewer.signalingClient.on('close', () => {
        console.log('[VIEWER] Disconnected from signaling channel');
    });

    viewer.signalingClient.on('error', error => {
        console.error('[VIEWER] Signaling client error: ', error);
    });

    viewer.signalingClient.on('disconnect', async () => {
        console.error('[VIEWER] Signaling disconnect');
    });

    // Send any ICE candidates to the other peer
    viewer.peerConnection.addEventListener('icecandidate', ({ candidate }) => {
        if (candidate) {
            console.log('[VIEWER] Generated ICE candidate');

            // When trickle ICE is enabled, send the ICE candidates as they are generated.
            if (formValues.useTrickleICE) {
                console.log('[VIEWER] Sending ICE candidate');
                viewer.signalingClient.sendIceCandidate(candidate);
            }
        } else {
            console.log('[VIEWER] All ICE candidates have been generated');

            // When trickle ICE is disabled, send the offer now that all the ICE candidates have ben generated.
            if (!formValues.useTrickleICE) {
                console.log('[VIEWER] Sending SDP offer');
                viewer.signalingClient.sendSdpOffer(viewer.peerConnection.localDescription);
            }
            if(connectionStatus===null){
                stopViewer(viewer);
                stateChangeNotifier('terminated', true);
            }
        }
    });

    // As remote tracks are received, add them to the remote view
    viewer.peerConnection.addEventListener('track', event => {
        console.log('[VIEWER] Received remote track');
        if (viewer.remoteView.srcObject) {
            return;
        }
        viewer.remoteStream = event.streams[0];
        viewer.remoteView.srcObject = viewer.remoteStream;
    });
    viewer.peerConnection.addEventListener('connectionstatechange', event => {
        console.log('[VIEWER] Received connectionstatechange:'+event.target.connectionState);
        connectionStatus = event.target.connectionState;

        if(event.target.connectionState==='disconnected' || event.target.connectionState==='failed'){
            stopViewer(viewer);
            stateChangeNotifier(connectionStatus,true);
        }else{
            stateChangeNotifier(connectionStatus,false);
        }
        //console.dir(event);
    });
    console.log('[VIEWER] Starting viewer connection');
    viewer.signalingClient.open();
}

export function stopViewer(viewer) {
    console.log('[VIEWER] Stopping viewer connection');
    if (viewer.signalingClient) {
        viewer.signalingClient.close();
        viewer.signalingClient = null;
    }

    if (viewer.peerConnection) {
        viewer.peerConnection.close();
        viewer.peerConnection = null;
    }

    if (viewer.localStream) {
        viewer.localStream.getTracks().forEach(track => track.stop());
        viewer.localStream = null;
    }

    if (viewer.remoteStream) {
        viewer.remoteStream.getTracks().forEach(track => track.stop());
        viewer.remoteStream = null;
    }

    if (viewer.peerConnectionStatsInterval) {
        clearInterval(viewer.peerConnectionStatsInterval);
        viewer.peerConnectionStatsInterval = null;
    }

    if (viewer.localView) {
        viewer.localView.srcObject = null;
    }

    if (viewer.remoteView) {
        viewer.remoteView.srcObject = null;
    }

    if (viewer.dataChannel) {
        viewer.dataChannel = null;
    }
}
/*
function sendViewerMessage(viewer, message) {
    if (viewer.dataChannel) {
        try {
            viewer.dataChannel.send(message);
        } catch (e) {
            console.error('[VIEWER] Send DataChannel: ', e.toString());
        }
    }
}
*/